const reserved={
    profiles:[2, 3],
    sudos:[3]
}
export default reserved;